module.exports = __webpack_public_path__ + "static/media/RATATTACK_es.ef447cfc.pdf";